"use strict";

require("core-js/modules/es.object.keys.js");

require("core-js/modules/es.symbol.js");

require("core-js/modules/es.array.filter.js");

require("core-js/modules/es.object.get-own-property-descriptor.js");

require("core-js/modules/web.dom-collections.for-each.js");

require("core-js/modules/es.object.get-own-property-descriptors.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("core-js/modules/es.object.assign.js");

var _userActionTypes = require("./userActionTypes");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var initialState = {
  busy: false,
  userContext: {},
  partnerContext: [],
  hasIdentified: false,
  hasGuestIdentified: false
};

var userReducer = function userReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case _userActionTypes.REQUEST_PARTNER_STATUS:
    case _userActionTypes.REQUEST_USER:
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          busy: true
        });
      }

    case _userActionTypes.RECEIVE_USER:
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          busy: false,
          userContext: action.payload
        });
      }

    case _userActionTypes.IDENTIFY_USER:
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          hasIdentified: true
        });
      }

    case _userActionTypes.IDENTIFY_GUEST_USER:
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          hasGuestIdentified: true
        });
      }

    case _userActionTypes.RECEIVE_USER_STATUS:
      {
        var updatedUserContext = Object.assign({}, state.userContext, {
          status: action.payload.status
        });
        return Object.assign({}, state, {
          busy: false,
          userContext: updatedUserContext
        });
      }

    case _userActionTypes.RECEIVE_PARTNER_STATUS:
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          busy: false,
          partnerContext: action.payload
        });
      }

    default:
      return state;
  }
};

var _default = userReducer;
exports.default = _default;